import {
    closestRequired,
    getAttributeOrThrow,
    qsRequired,
} from '@/scripts/core/global'
import {uCoastWindow} from '@/scripts/setup'
import {QuickAddModal} from '@/scripts/optional/quick-add'
import {ProductForm} from "@/scripts/product/product-form";
import {UcoastEl} from "@/scripts/core/UcoastEl";
import {ProductVariant} from "@/scripts/types/api";

declare let window: uCoastWindow

export class QuickAddCard extends UcoastEl {
    static htmlSelector = 'quick-add-card'
    productId: string
    productForm: ProductForm
    closeModalButton: HTMLButtonElement
    parentModal?: QuickAddModal
    variantData: ProductVariant[]
    currentVariantId: number

    constructor() {
        super()
        this.productId = getAttributeOrThrow('data-uc-product-id', this)
        this.variantData = this.getVariantData()
        this.closeModalButton = qsRequired<HTMLButtonElement>(
            `[data-uc-quick-add-close-modal][data-uc-product-id="${this.productId}"]`
        )
        this.parentModal = qsRequired<QuickAddModal>(
            `quick-add-modal[data-uc-product-id="${this.productId}"]`
        )
        this.productForm = closestRequired(this, 'product-form')
        this.currentVariantId = parseInt(getAttributeOrThrow('value', this.productForm.formIdEl))
        if (this.currentVariantId !== this.variantData[0].id) {
            this.updateButtonText()
        }
    }

    updateButtonText() {
        const currentVariant = this.variantData.find(variant => variant.id === this.currentVariantId)
        if (!currentVariant) {
            console.error('no variants available')
            return
        }
        const price = this.formatShopifyPrice(currentVariant.price, currentVariant.compare_at_price)
        const statusTextEl = qsRequired('[data-uc-inventory-status-text]', this.productForm.submitButton)
        const priceTextEl = qsRequired('[data-uc-price-variable]', this.productForm.submitButton)

        statusTextEl.innerHTML = currentVariant.inventory_status_text.replace('+ ', '')
        priceTextEl.innerHTML = price
        if (!currentVariant.available) {
            this.productForm.submitButton.setAttribute('data-uc-klaviyo-oos-popup-trigger', `${currentVariant.id}`)
        } else {
            this.productForm.submitButton.removeAttribute('data-uc-klaviyo-oos-popup-trigger')
        }
    }

    formatShopifyPrice(price: number, comparePrice?: number): string {
        if (comparePrice && comparePrice > price) {
            const comparePriceString =
                comparePrice % 100 === 0
                    ? `$${(comparePrice / 100).toFixed(0)}`
                    : `$${(comparePrice / 100).toFixed(2)}`
            const priceString =
                price % 100 === 0 ? `$${(price / 100).toFixed(0)}` : `$${(price / 100).toFixed(2)}`
            return `<s>${comparePriceString}</s> ${priceString}`
        } else {
            return price % 100 === 0
                ? `$${(price / 100).toFixed(0)}`
                : `$${(price / 100).toFixed(2)}`
        }
    }

    getVariantData(): ProductVariant[] {
        const textContent = qsRequired<HTMLScriptElement>(
            '[type="application/json"]',
            this
        ).textContent
        if (!textContent) throw new Error('Variant data not found')
        const updatedVariantData = this.variantData ?? JSON.parse(textContent)
        this.variantData = updatedVariantData
        return updatedVariantData
    }

    override connectedCallback() {
        super.connectedCallback()
        this.closeModalButton.addEventListener('click', (event: Event) => {
            event.preventDefault()
            if (!this.parentModal) {
                throw new Error('Close modal button does not have a parent modal')
            }
            this.parentModal.hide()
        })
        this.addEventListener('ucoast-select-change', (e) => {
            const variantIdString = e?.detail?.value
            console.log({variantIdString})
            if (!variantIdString) {
                console.error('need variantId in event.detail.value')
                return
            }
            const variantId = parseInt(variantIdString)
            this.productForm.formIdEl.value = variantIdString
            this.currentVariantId = variantId
            this.updateButtonText()

        })
    }

}
